'use client'

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { ImageBlock as ImageBlockType } from '@/payload-types'
import { ImageBlock } from './ImageBlock'
import { useTranslations } from 'next-intl'

export default function ImageCarousel({
  media,
  imageRatio,
  loading = false,
}: {
  media: { image?: ImageBlockType; id?: string | null }[]
  imageRatio?: number
  loading?: boolean
}) {
  const [api, setApi] = useState<CarouselApi>()
  const [current, setCurrent] = useState(0)
  const [count, setCount] = useState(0)
  const t = useTranslations()

  useEffect(() => {
    if (!api) {
      return
    }

    setCount(media.slice(0, 10).length)
    setCurrent(api.selectedScrollSnap() + 1)

    api.on('select', () => {
      setCurrent(api.selectedScrollSnap() + 1)
    })
  }, [api, media])

  if (media.length === 0) return null

  if (media.length === 1) {
    return (
      <ImageBlock ratio={16 / 9} imageBlock={media[0].image} fill imgClassName='object-cover' />
    )
  }

  return (
    <div className='relative w-full'>
      <Carousel
        plugins={[WheelGesturesPlugin()]}
        setApi={setApi}
        opts={{
          skipSnaps: true,
        }}
        className='overflow-x-hidden'
      >
        <CarouselContent>
          {media.slice(0, 10).map((mediaItem, index) => (
            <CarouselItem key={mediaItem.id} className='p-0'>
              <ImageBlock
                ratio={16 / 9}
                imageBlock={mediaItem.image}
                fill
                imgClassName='object-cover'
              />
            </CarouselItem>
          ))}
        </CarouselContent>

        {/*<CarouselPrevious className="left-2 z-10" />
        <CarouselNext className="right-2 z-10" />*/}
      </Carousel>
      <div className='absolute bottom-0 flex w-full justify-center'>
        {Array.from({ length: count }).map((_, index) => (
          <button
            onClick={() => api?.scrollTo(index)}
            key={index}
            aria-label={t('go_to_slide', { number: index + 1 })}
            aria-current={index === current - 1 ? 'true' : undefined}
            className='my-2 flex size-6 items-center justify-center'
          >
            <span
              className={cn(
                'h-2 w-2 rounded-full opacity-100 transition-all duration-500 ease-in-out',
                {
                  'opacity-0': loading,
                  'scale-150 bg-white': index === current - 1,
                  'bg-white/40': index !== current - 1,
                },
              )}
            />
          </button>
        ))}
      </div>
    </div>
  )
}
